/* eslint-disable max-len */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getIsUrgentDeliveryEnabled, updateUrgentDelivery } from 'domains/deliveryLeadTime/DeliveryLeadTime.store';
import { Box, Flex, Switch, Text } from 'UI';

const UrgentDelivery = () => {
  const isUrgentDeliveryEnabled = useSelector(getIsUrgentDeliveryEnabled);
  const [isButtonChecked, setIsButtonChecked] = useState(isUrgentDeliveryEnabled);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Flex direction={'column'}>
      <Box height={40} />
      <Flex direction={'row'}>
        <Text type="heading3">
          {t('backoffice.delivery_lead_time.urgent.title', 'Default configuration for urgent orders')}
        </Text>
      </Flex>

      <Text type="base">
        {t(
          'backoffice.delivery_lead_time.urgent.description',
          'Activate urgent orders selection. Select by default all the urgent order boxes for all the references in the client basket.',
        )}
      </Text>
      <Box height={30} />
      <Flex direction={'row'}>
        <Text type="base">{t('backoffice.delivery_lead_time.urgent.activate', 'Activate')}</Text>
        <Flex maxWidth={650} />
        <Switch
          checked={isButtonChecked}
          onChange={() => {
            setIsButtonChecked(!isButtonChecked);
            dispatch(
              updateUrgentDelivery({
                isEnabled: !isUrgentDeliveryEnabled,
              }),
            );
          }}
        />
      </Flex>
      <Box height={30} />
    </Flex>
  );
};

export default UrgentDelivery;
